import { StyleDataTable as DataTable } from './DataTable';

export default DataTable;
